export function getIdentifierAutomatizedTest(): string {
  const year: number = new Date().getFullYear();
  const monther: number = new Date().getMonth() + 1;
  return `!Edenred@Test-$${monther}-$${year}`;
}

export function getIdentifierTestQa(): string {
  const year: number = new Date().getFullYear();
  const monther: number = new Date().getMonth() + 1;
  return `!Edenred@TestQa-$${monther}-$${year}`;
}
